"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _useProductsAndFiltersFromCategory = require("./useProductsAndFiltersFromCategory");
var _LanguageProvider = require("../common/LanguageProvider");
var _cache = require("@deosite/helpers/cache");
var _createFilterString = _interopRequireDefault(require("@deosite/helpers/createFilterString"));
var _replaceSpecialCharacters = _interopRequireDefault(require("@deosite/helpers/replaceSpecialCharacters"));
var _addSortFilters = _interopRequireDefault(require("../common/addSortFilters"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _filters = require("@deosite/helpers/filters");
var _excluded = ["sort"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useFilters = function useFilters(initialProducts, categoryId, initialFilters, initialPage, allFilters, router, pageSize, isFirstRun, cacheSSR) {
  var _initialFilters$filte, _initialFilters$filte2;
  var disabledFilters = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var _useState = (0, _react.useState)(false),
    isPending = _useState[0],
    setPending = _useState[1];
  var translations = {
    recommended: (0, _langLibrary["default"])("recommended"),
    priceCatalogHigh: (0, _langLibrary["default"])("price catalog low to high"),
    priceCatalogLow: (0, _langLibrary["default"])("price catalog high to low"),
    finalPriceHigh: (0, _langLibrary["default"])("price low to high"),
    finalPriceLow: (0, _langLibrary["default"])("price high to low"),
    sortByNameDesc: (0, _langLibrary["default"])("sortByNameDesc"),
    sortByNameAsc: (0, _langLibrary["default"])("sortByNameAsc")
  };
  var _useState2 = (0, _react.useState)({
      products: initialProducts,
      activeFilters: initialFilters,
      productsAmount: false,
      page: initialPage,
      currentCategory: categoryId,
      pickedFiltersKeys: (_initialFilters$filte = initialFilters === null || initialFilters === void 0 ? void 0 : (_initialFilters$filte2 = initialFilters.filter(function (filter) {
        return filter.value;
      })) === null || _initialFilters$filte2 === void 0 ? void 0 : _initialFilters$filte2.map(function (filter) {
        return filter.id;
      })) !== null && _initialFilters$filte !== void 0 ? _initialFilters$filte : [],
      allFilters: allFilters
    }),
    filtersState = _useState2[0],
    setFiltersState = _useState2[1];
  (0, _react.useEffect)(function () {
    var _initialFilters$map;
    if (isPending) return;
    setFiltersState(_objectSpread(_objectSpread({}, filtersState), {}, {
      products: initialProducts,
      activeFilters: (_initialFilters$map = initialFilters === null || initialFilters === void 0 ? void 0 : initialFilters.map(function (filter) {
        if (disabledFilters !== null && disabledFilters !== void 0 && disabledFilters.includes(filter.id)) {
          return _objectSpread(_objectSpread({}, filter), {}, {
            isDisabled: true
          });
        }
        if (filter.id === "capacity") {
          var _filter$value, _filter$value2, _filter$value3;
          return ((_filter$value = filter.value) === null || _filter$value === void 0 ? void 0 : _filter$value.to) !== undefined ? _objectSpread(_objectSpread({}, filter), {}, {
            value: {
              to: ((_filter$value2 = filter.value) === null || _filter$value2 === void 0 ? void 0 : _filter$value2.to) / 1000,
              from: ((_filter$value3 = filter.value) === null || _filter$value3 === void 0 ? void 0 : _filter$value3.from) / 1000
            },
            isConverted: true,
            max: filter.max / 1000,
            min: filter.min / 1000
          }) : _objectSpread(_objectSpread({}, filter), {}, {
            isConverted: true,
            max: filter.max / 1000,
            min: filter.min / 1000
          });
        }
        return filter;
      })) !== null && _initialFilters$map !== void 0 ? _initialFilters$map : [],
      currentCategory: categoryId,
      page: initialPage
    }));
  }, [initialFilters, categoryId, initialProducts]);
  var onFiltersChange = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(filtersValue) {
      var _pickedFilters$sort, _pickedFilters$sort2, _url;
      var page,
        requestPath,
        categories,
        currentCategory,
        prismicCategory,
        proCategoryString,
        _filtersReduce,
        pickedFilters,
        pickedFiltersKeys,
        newlyPickedFilterKey,
        sort,
        pickedValueWithoutSort,
        filtersRangeString,
        pageString,
        url,
        isSort,
        sortString,
        urlToCheck,
        responseFromCache,
        response,
        newFilters,
        _args = arguments;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              page = _args.length > 1 && _args[1] !== undefined ? _args[1] : 1;
              requestPath = _args.length > 2 ? _args[2] : undefined;
              categories = _args.length > 3 ? _args[3] : undefined;
              currentCategory = _args.length > 4 ? _args[4] : undefined;
              prismicCategory = _args.length > 5 ? _args[5] : undefined;
              proCategoryString = _args.length > 6 && _args[6] !== undefined ? _args[6] : false;
              setPending(true);
              _filtersReduce = (0, _filters.filtersReduce)(filtersValue, filtersState.pickedFiltersKeys), pickedFilters = _filtersReduce.pickedFilters, pickedFiltersKeys = _filtersReduce.pickedFiltersKeys, newlyPickedFilterKey = _filtersReduce.newlyPickedFilterKey;
              sort = pickedFilters.sort, pickedValueWithoutSort = (0, _objectWithoutProperties2["default"])(pickedFilters, _excluded);
              filtersRangeString = "";
              Object.keys(pickedValueWithoutSort).map(function (filter) {
                if (filter === "capacity") {
                  pickedValueWithoutSort[filter] = _objectSpread(_objectSpread({}, pickedValueWithoutSort[filter]), {}, {
                    from: pickedValueWithoutSort[filter].from / 1000,
                    to: pickedValueWithoutSort[filter].to / 1000
                  });
                }
                if (!Array.isArray(pickedValueWithoutSort[filter])) {
                  filtersRangeString += "".concat(filtersRangeString ? "-" : "").concat(filter, "-").concat(pickedValueWithoutSort[filter].from, "-").concat(pickedValueWithoutSort[filter].to);
                  delete pickedValueWithoutSort[filter];
                } else {
                  var pickedValue = pickedValueWithoutSort[filter].map(function (filter) {
                    return filter.name.toLowerCase();
                  }).flat();
                  filtersRangeString += "".concat(filtersRangeString ? "-" : "").concat(pickedValue === null || pickedValue === void 0 ? void 0 : pickedValue.join("-"));
                  delete pickedValueWithoutSort[filter];
                }
              });
              if (filtersRangeString) {
                filtersRangeString = "/".concat(filtersRangeString).replace(/ \/ /g, "_").replace(/ & /g, "_").replace(/ /g, "_");
              }
              pageString = page > 1 ? "p=".concat(page) : null;
              isSort = (pickedFilters === null || pickedFilters === void 0 ? void 0 : (_pickedFilters$sort = pickedFilters["sort"]) === null || _pickedFilters$sort === void 0 ? void 0 : _pickedFilters$sort.value) && (pickedFilters === null || pickedFilters === void 0 ? void 0 : (_pickedFilters$sort2 = pickedFilters["sort"]) === null || _pickedFilters$sort2 === void 0 ? void 0 : _pickedFilters$sort2.value.split("-"));
              sortString = isSort ? "?dir=" + (isSort === null || isSort === void 0 ? void 0 : isSort[1]) + "&order=" + (isSort === null || isSort === void 0 ? void 0 : isSort[0]) : "";
              url = "".concat(requestPath).concat(filtersRangeString).concat(sortString);
              if (pageString) {
                url = "".concat(url).concat(url.includes("?") ? "&" + pageString : "?" + pageString);
              }
              url = (0, _replaceSpecialCharacters["default"])(url);
              urlToCheck = proCategoryString ? proCategoryString : "".concat(((_url = url) === null || _url === void 0 ? void 0 : _url[0]) !== "/" ? "/" : "").concat(url);
              responseFromCache = (0, _cache.getResultFromCache)(urlToCheck, cacheSSR);
              if (!(responseFromCache !== null && responseFromCache !== void 0)) {
                _context.next = 24;
                break;
              }
              _context.t0 = responseFromCache;
              _context.next = 27;
              break;
            case 24:
              _context.next = 26;
              return (0, _useProductsAndFiltersFromCategory.fetcher)(categoryId, pickedFilters, page, pageSize, null, language);
            case 26:
              _context.t0 = _context.sent;
            case 27:
              response = _context.t0;
              (0, _addSortFilters["default"])(response === null || response === void 0 ? void 0 : response.narrowedFilters, translations);
              filtersValue = Array.isArray(filtersValue) ? filtersValue : [filtersValue];
              newFilters = (0, _filters.filtersSetValue)(response === null || response === void 0 ? void 0 : response.narrowedFilters, filtersValue, newlyPickedFilterKey, pickedFiltersKeys);
              if (!responseFromCache) {
                (0, _cache.setUrlInCache)(proCategoryString ? proCategoryString : "/".concat(url), _objectSpread(_objectSpread({}, response), {}, {
                  categories: categories,
                  currentCategory: currentCategory,
                  prismicCategory: prismicCategory
                }), cacheSSR);
              }
              setFiltersState({
                page: page,
                productsAmount: response.productsTotalCount,
                activeFilters: newFilters,
                products: response.products,
                previousCategory: filtersState.currentCategory,
                currentCategory: categoryId,
                pickedFiltersKeys: pickedFiltersKeys,
                allFilters: filtersState.allFilters
              });
              setPending(false);
              return _context.abrupt("return", (0, _createFilterString["default"])(newFilters));
            case 35:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function onFiltersChange(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    products: filtersState.products,
    page: initialPage,
    productsAmount: filtersState.previousCategory !== filtersState.currentCategory ? false : filtersState.productsAmount,
    activeFilters: filtersState.activeFilters,
    onFiltersChange: onFiltersChange
  };
};
var _default = useFilters;
exports["default"] = _default;